module.exports = __webpack_public_path__ + "img/link-banner-kr.e0d66348.png";